module.exports = __webpack_public_path__ + "img/20110201_01.943fc206.jpg";